import { render, staticRenderFns } from "./SpamEmail.vue?vue&type=template&id=531096d7&"
import script from "./SpamEmail.vue?vue&type=script&lang=js&"
export * from "./SpamEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports